(function () {
  var STORAGE_KEY = 'edas-cookie-consent';
  var APPEAR_DELAY_MS = 1000;
  var HIDE_ANIMATION_MS = 360;
  var popup = document.getElementById('edas-cookie-consent');
  var acceptBtn = document.getElementById('edas-cookie-accept');
  var rejectBtn = document.getElementById('edas-cookie-reject');
  var settingsBtn = document.getElementById('edas-cookie-settings');
  var showTimeoutId = null;
  var isVisible = false;

  function getStored() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      if (value === 'accepted' || value === 'rejected') {
        return value;
      }
    } catch (e) {}

    return '';
  }

  function setStored(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
  }

  function grantAnalytics() {
    if (typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('consent', 'update', {
      analytics_storage: 'granted'
    });
    window.gtag('event', 'page_view');
  }

  function clearAnalyticsCookies() {
    var names = document.cookie.split(';');
    var host = window.location.hostname;
    var domains = [host, '.' + host];

    if (host.indexOf('www.') === 0) {
      domains.push(host.slice(4));
      domains.push('.' + host.slice(4));
    }

    names.forEach(function (cookie) {
      var name = cookie.split('=')[0].trim();
      if (name !== '_gid' && name.indexOf('_ga') !== 0) {
        return;
      }

      domains.forEach(function (domain) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + domain;
      });
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    });
  }

  if (settingsBtn && settingsBtn.getAttribute('data-consent-mode') === 'google') {
    settingsBtn.addEventListener('click', function () {
      function showRevocation() {
        if (window.googlefc && typeof window.googlefc.showRevocationMessage === 'function') {
          window.googlefc.showRevocationMessage();
        }
      }

      if (window.googlefc && typeof window.googlefc.showRevocationMessage === 'function') {
        showRevocation();
        return;
      }

      window.googlefc = window.googlefc || {};
      window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
      window.googlefc.callbackQueue.push(showRevocation);
    });
    return;
  }

  if (!popup || !acceptBtn || !rejectBtn) {
    return;
  }

  function showPopup() {
    if (isVisible) {
      return;
    }

    isVisible = true;
    popup.hidden = false;
    popup.classList.remove('is-leaving');
    popup.classList.add('is-visible');

    requestAnimationFrame(function () {
      popup.classList.add('is-entering');
    });
  }

  function hidePopup() {
    if (!isVisible) {
      return;
    }

    isVisible = false;
    popup.classList.remove('is-entering');
    popup.classList.add('is-leaving');

    setTimeout(function () {
      popup.classList.remove('is-visible');
      popup.classList.remove('is-leaving');
      popup.hidden = true;
    }, HIDE_ANIMATION_MS);
  }

  function schedulePopupAppearance() {
    if (showTimeoutId !== null) {
      clearTimeout(showTimeoutId);
    }

    showTimeoutId = setTimeout(function () {
      showPopup();
      showTimeoutId = null;
    }, APPEAR_DELAY_MS);
  }

  if (getStored() === '') {
    if (document.readyState === 'complete') {
      schedulePopupAppearance();
    } else {
      window.addEventListener('load', schedulePopupAppearance, { once: true });
    }
  }

  if (settingsBtn) {
    settingsBtn.addEventListener('click', function () {
      if (showTimeoutId !== null) {
        clearTimeout(showTimeoutId);
        showTimeoutId = null;
      }
      showPopup();
    });
  }

  acceptBtn.addEventListener('click', function () {
    setStored('accepted');
    grantAnalytics();
    hidePopup();
  });

  rejectBtn.addEventListener('click', function () {
    var previous = getStored();
    setStored('rejected');

    if (previous === 'accepted') {
      clearAnalyticsCookies();
      window.location.reload();
      return;
    }

    hidePopup();
  });
})();
